import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { useTranslation } from 'react-i18next';

import { Img } from 'react-image';
import { Grid, Box, CircularProgress } from '@material-ui/core';
import { isEmpty } from 'lodash';

import { styles } from '../style';

const useStyles = makeStyles(styles);

export default function WaterLavelDatalists() {
  const { t } = useTranslation();
  const [hasError, sethasError] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const hostApi = `${process.env.REACT_APP_API_URL}`;
  const placeHolder = 'https://via.placeholder.com/600x720?text=Loading&italic=true';
  const [SeaAnimation, setSeaAnimation] = useState({});

  useEffect(() => {
    function getData() {
      setLoading(true);
      fetch(`${hostApi}/public/wave_forecast_animation_img`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((data) => {
          setSeaAnimation(...data.data);
          setLoading(false);
        })
        .catch(() => { sethasError(true); });
    }
    getData();
  }, [hostApi]);

  const classes = useStyles();
  return (
    <>
      {hasError && (
        <div>
          Error Occured
        </div>
      )}
      {isLoading && (
        <div className="Loading">
          <CircularProgress />
        </div>
      )}
      <div className={classes.root}>
        <Grid container>
          <Grid item md className={classes.bodyAnimationBox}>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs sm md={8}>
                <Box display="block" mt={2}>
                  {isEmpty(SeaAnimation) === false ? (
                    <Box className={classes.bodyBox}><Img src={`${hostApi}/shared/image?_csrf=&image=${SeaAnimation.media_path}`} alt={SeaAnimation.media_datetime} className={classes.img} unloader={(<Img src={placeHolder} alt="ไม่มีข้อมูล" />)} /></Box>
                  ) : (
                    <Box className={classes.bodyBox}><img src={placeHolder} alt={t('ไม่มีข้อมูล')} /></Box>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
